import * as React from 'react';
export const IcNatureOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.12 3.64A6 6 0 006 8c0 .373.038.745.11 1.11a4 4 0 00-2.05 6.59L16.12 3.64zm1.77 5.47c.072-.365.109-.737.11-1.11.01-.176.01-.353 0-.53L20.49 5A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49L8.44 17H11v3H9a1 1 0 000 2h6a1 1 0 100-2h-2v-3h4a4 4 0 00.89-7.89z'
      fill='currentColor'
    />
  </svg>
);
